import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import Button from "react-bootstrap/lib/Button";
import Row from "react-bootstrap/lib/Row";
import Collapse from "react-bootstrap/lib/Collapse";
import cx from "classnames";
import * as FontAwesome from "react-icons/lib/fa";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import ListItem from "./ListItem";
import Link from "../../Link";
import Loader from "../../Loader";
import ListBedTypes from "./ListBedTypes";

import messages from "../../../locale/messages";
import { getSpecificSettings } from "../../../actions/getSpecificSettings";
import { contactHostOpen } from "../../../actions/message/contactHostModal";
import { checkIn, checkValue } from "./helper";

import roomTypeIcon from "/public/SiteIcons/listingRoomTypeIcon.svg";
import guestIcon from "/public/SiteIcons/listingGuestIcon.svg";
import bedIcon from "/public/SiteIcons/listingBedIcon.svg";
import bathIcon from "/public/SiteIcons/listingBathIcon.svg";
import checkInIcon from "/public/SiteIcons/listingCheckIcon.svg";
import rightArrow from "/public/SiteIcons/viewProfileArrow.svg";
import totalRoom from "/public/SiteIcons/totalRooms.svg";
import bathroomIcon from "/public/SiteIcons/bathrooms.svg";
import s from "./ListingDetails.css";

class ListingDetails extends React.Component {
  static propTypes = {
    data: PropTypes.shape({
      listingData: PropTypes.shape({
        cancellation: PropTypes.shape({
          policyName: PropTypes.string.isRequired,
          policyContent: PropTypes.string.isRequired,
        }),
      }),
    }),
    getSpecificSettings: PropTypes.any,
    settingsData: PropTypes.object,
    isHost: PropTypes.bool.isRequired,
    formatMessage: PropTypes.any,
    userBanStatus: PropTypes.number,
    urlParameters: PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      guests: PropTypes.string,
      listTitle: PropTypes.string,
    }),
  };
  static defaultProps = {
    isHost: false,
    description: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isLoad: false,
    };

    this.checkDogAmenetiesAvailable = this.isDogAmenitiesEmpty.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoad: false });
  }

  UNSAFE_componentWillMount() {
    this.setState({ isLoad: true });
  }

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  isDogAmenitiesEmpty(dogAmenities) {
    if (!dogAmenities) return true;

    const relevantKeys = [
      "fencingHeight",
      "secureDogAreaType",
      "gatesType",
      "sizeOfDog",
      "numberOfDogs",
      "dogBed",
      "doggyDoorGap",
      "fencingDescription",
      "gatesDescription",
      "fenceCondition",
      "fenceType",
    ];

    return relevantKeys.every((key) => {
      const value = dogAmenities[key];
      return (
        value === null || value === undefined || value === 0 || value === "0"
      );
    });
  }

  render() {
    const { data } = this.props;
    const { formatMessage } = this.props.intl;
    const { open, isLoad } = this.state;

    const captionTitle = checkValue(data?.captionTitle, "");
    const photo = checkValue(data?.photo, ""); // This is the base64 string

    let checkInStart, checkInEnd, roomType, buildingSize, bathroomType;
    let userAmenities = [],
      userSafetyAmenities = [],
      dogFriendlyAmenities = {};
    let sharedSpaces = [],
      houseRules = [],
      listBedTypes = [];
    let description,
      personCapacity,
      bathrooms,
      bedrooms,
      bedCounts = 0;
    let count = 150,
      firstArray,
      restArray,
      dotString = false;
    let isAmenities,
      isSharedSpaces,
      bedResult = [];

    if (data.listingData != undefined) {
      checkInStart = checkValue(data?.listingData?.checkInStart, "");
      checkInEnd = checkValue(data?.listingData?.checkInEnd, "");
    }
    if (data.settingsData != undefined && data?.settingsData?.length > 0) {
      roomType = checkValue(data?.settingsData[0]?.listsettings?.itemName, "");
      buildingSize = checkValue(
        data?.settingsData[2]?.listsettings?.itemName,
        ""
      );
      bathroomType = checkValue(
        data?.settingsData[3]?.listsettings?.itemName ||
          data?.settingsData[2]?.listsettings?.itemName,
        ""
      );
    }
    sharedSpaces = checkValue(data?.userSpaces, []);
    houseRules = checkValue(data?.houseRules, []);
    userAmenities = checkValue(data?.userAmenities, []);
    dogFriendlyAmenities = checkValue(data?.dogFriendlyAmenities, {});
    userSafetyAmenities = checkValue(data?.userSafetyAmenities, []);

    const extraEmenities = {
      userSafetyAmenities,
      dogFriendlyAmenities,
    };

    description = checkValue(data?.description, "");
    personCapacity = checkValue(data?.personCapacity, 0);
    bathrooms = checkValue(data?.bathrooms, 0);
    bedrooms = checkValue(data?.bedrooms, 0);
    listBedTypes = checkValue(data?.listBedTypes, []);

    if (listBedTypes && listBedTypes?.length > 0) {
      bedResult = listBedTypes?.reduce(
        (acc, o) => (
          (acc[o.listsettings && o.listsettings.itemName] =
            (acc[o.listsettings && o.listsettings.itemName] || 0) + 1),
          acc
        ),
        {}
      );
      bedCounts = Object.values(bedResult);
      bedCounts = bedCounts.reduce((a, b) => a + b, 0);
    }

    if (description) {
      firstArray = description?.slice(0, count);
      restArray = description?.slice(count, description?.length);
    }
    if (restArray && restArray?.length > 0) {
      dotString = true;
    }

    userAmenities?.map((item) => {
      if (item?.listsettings?.isEnable == "1") {
        isAmenities = true;
      }
    });

    sharedSpaces?.map((item) => {
      if (item?.listsettings?.isEnable == "1") {
        isSharedSpaces = true;
      }
    });

    return (
      <Row className={cx(s.pageContent)}>
        <div className={cx(s.horizontalLineThrough)}>
          <div className={cx(s.space1)}>
            <p className={s.sectionTitleText}>
              <FormattedMessage {...messages.theSpace} />
            </p>
          </div>
          {!isLoad && (
            <div className={s.grid}>
              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={roomTypeIcon} className={cx(s.spaceIcons)} />
                </div>
                <div className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.roomType} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>{roomType}</div>
                </div>
              </p>
              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={guestIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.guests} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {personCapacity}{" "}
                    {personCapacity > 1 ? (
                      <FormattedMessage {...messages.guests} />
                    ) : (
                      <FormattedMessage {...messages.guests} />
                    )}
                  </div>
                </span>
              </p>

              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={bedIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.bedrooms} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {bedrooms}{" "}
                    {bedrooms > 1 ? (
                      <FormattedMessage {...messages.bedrooms} />
                    ) : (
                      <FormattedMessage {...messages.bedroom} />
                    )}
                  </div>
                </span>
              </p>

              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={bedIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.bedsCapital} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {bedCounts}{" "}
                    {bedCounts > 1 ? (
                      <FormattedMessage {...messages.beds} />
                    ) : (
                      <FormattedMessage {...messages.bed} />
                    )}
                  </div>
                </span>
              </p>

              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={bathroomIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.bathrooms} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {bathrooms}{" "}
                    {bathrooms > 1 ? (
                      <FormattedMessage {...messages.bathrooms} />
                    ) : (
                      <FormattedMessage {...messages.bathroom} />
                    )}
                  </div>
                </span>
              </p>

              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={checkInIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.checkIn} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {checkIn(checkInStart, checkInEnd)}
                  </div>
                </span>
              </p>

              <p className={s.flex}>
                <div className={cx(s.svgImg, "svgImg")}>
                  <img src={bathIcon} className={cx(s.spaceIcons)} />
                </div>
                <span className={cx(s.textCss)}>
                  <div className={cx(s.fontColor)}>
                    <FormattedMessage {...messages.bathroomType} />
                  </div>
                  <div className={cx(s.smallText, "textWhite")}>
                    {bathroomType}
                  </div>
                </span>
              </p>
            </div>
          )}
          {isLoad && <Loader type={"text"} />}
        </div>
        <div className={s.listingLine}></div>
        <div className={cx(s.horizontalLineThrough)}>
          {/* Create a single row with two 50% grid sections */}
          <div className={cx(s.gridContainer, s.captionImage)}>
            {/* First Partition: Your existing content */}

            <div className={cx(s.gridItem)}>
              <h2 className={cx(s.sectionTitleText)}>
                <FormattedMessage {...messages.aboutListing} />
              </h2>

              <p className={cx(s.listingFontSize)}>
                {/* If not expanded, show the first 500 chars */}
                {!this.state.open && (
                  <span className={cx(s.subText, s.lineBreak)}>
                    {description?.slice(0, 500)}
                    {description?.length > 500 && <span>... </span>}
                  </span>
                )}

                {/* If expanded, show the full description only */}
                {this.state.open && (
                  <span className={cx(s.subText, s.lineBreak)}>
                    {description}
                  </span>
                )}

                {/* Toggle button */}
                {description?.length > 500 && (
                  <div className={s.btnContainer}>
                    <div className={s.showHidePadding}>
                      <Button
                        bsStyle="link"
                        className={cx(
                          s.button,
                          s.noPadding,
                          s.btnLInk,
                          s.showHideBtn,
                          "bgTransparent"
                        )}
                        onClick={() => this.handleClick()}
                      >
                        {this.state.open ? (
                          <FormattedMessage {...messages.closeSafetyFeatures} />
                        ) : (
                          <FormattedMessage {...messages.showMore} />
                        )}
                        {this.state.open ? (
                          <FontAwesome.FaAngleUp className={s.navigationIcon} />
                        ) : (
                          <FontAwesome.FaAngleDown
                            className={s.navigationIcon}
                          />
                        )}
                      </Button>
                    </div>
                  </div>
                )}
              </p>
            </div>

            {/* Second Partition: Display caption and photo */}

            <div className={cx(s.gridItem)}>
              {photo && (
                <div className={s.imageContainer}>
                  <img
                    src={photo}
                    alt={captionTitle || "Listing photo"}
                    className={s.listingImage}
                  />
                  {captionTitle && (
                    <div className={s.topLeftCaption}>
                      <h3 className={s.captionTitle}>{captionTitle}</h3>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={cx(s.listingLine, s.listingLineTwo)}></div>
        {listBedTypes?.length > 0 && listBedTypes[0]?.bedType && (
          <div>
            {" "}
            <ListBedTypes
              itemList={listBedTypes}
              label={formatMessage(messages.bedsCapital)}
            />
            <div className={cx(s.listingLine, s.listingLineTwo)}></div>
          </div>
        )}

        {userAmenities?.length > 0 && isAmenities && (
          <div>
            {" "}
            <ListItem
              itemList={userAmenities}
              label={formatMessage(messages.aminities)}
              showLabel={formatMessage(messages.showAmenities)}
              hideLabel={formatMessage(messages.closeAmenities)}
              icon={true}
            />
            <div className={s.listingLine}></div>
          </div>
        )}
        {Object.keys(extraEmenities).length !== 0 &&
          (extraEmenities.userSafetyAmenities.length ||
            !this.isDogAmenitiesEmpty(extraEmenities.dogFriendlyAmenities)) && (
            <div>
              <ListItem
                itemList={extraEmenities}
                isItemForDog={true}
                label={formatMessage(messages.safetyamenities)}
                showLabel={formatMessage(messages.showAllSafetyFeatures)}
                hideLabel={formatMessage(messages.closeSafetyFeatures)}
                icon={true}
              />
              <div className={s.listingLine}></div>
            </div>
          )}

        {/* {sharedSpaces?.length > 0 && isSharedSpaces && (
          <div>
            {" "}
            <ListItem
              itemList={sharedSpaces}
              label={formatMessage(messages.sharedSpaces)}
              showLabel={formatMessage(messages.showAllSharedSpaces)}
              hideLabel={formatMessage(messages.closeAllSharedSpaces)}
              icon={true}
            />
            <div className={s.listingLine}></div>
          </div>
        )} */}

        {houseRules?.length > 0 && (
          <div>
            {" "}
            <ListItem
              itemList={houseRules}
              label={formatMessage(messages.houseRules)}
              showLabel={formatMessage(messages.showAllHouseRules)}
              hideLabel={formatMessage(messages.closeHouseRules)}
              icon={false}
              houseRulesIcon={true}
            />
            <div className={s.listingLine}></div>
          </div>
        )}

        {data?.listingData?.cancellation && (
          <div className={cx(s.horizontalLineThrough)}>
            <div className={cx(s.space1)}>
              <p className={s.sectionTitleText}>
                <FormattedMessage {...messages.cancellations} />
              </p>
            </div>
            <div className={cx(s.spaceTop1)}>
              <p className={s.listingFontSize}>
                <span className={cx(s.text)}>
                  <span>{data?.listingData?.cancellation?.policyName}</span>
                </span>
              </p>
              <p className={s.listingFontSize}>
                <span className={cx(s.text, s.grayFontColor)}>
                  {data?.listingData?.cancellation?.policyContent}
                </span>
              </p>
              <div className={cx(s.listingFontSize, s.showHideMargin)}>
                <Link
                  to={
                    "/cancellation-policies/" +
                    data?.listingData?.cancellation?.policyName
                  }
                  className={cx(s.sectionCaptionLink, s.viewFlex)}
                >
                  <FormattedMessage {...messages.viewDetails} />{" "}
                  <img src={rightArrow} className={"detailsArrowRTL"} />
                </Link>
              </div>
            </div>
            <div className={s.listingLine}></div>
          </div>
        )}
      </Row>
    );
  }
}
const mapState = (state) => ({
  settingsData: state?.viewListing?.settingsData,
});
const mapDispatch = {
  getSpecificSettings,
  contactHostOpen,
};
export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(ListingDetails))
);
